import { FeatureSwitchInfo, SystemFlowInfo } from '@if/core/types'
import { createContext, useContext } from 'react'

export interface AppConfigContextValue {
  isInitializing: boolean
  featureSwitchInfo: FeatureSwitchInfo | null
  systemFlowInfo: SystemFlowInfo | null
}

export const AppConfigContext = createContext<AppConfigContextValue | null>(null)

export function useAppConfigContext(): AppConfigContextValue {
  const context = useContext(AppConfigContext)
  if (!context) {
    throw new Error('useAppConfigContext must be used within an AppConfigProvider')
  }
  return context
}
